import { MenuItem } from '@mui/material';
import { SelectItemDTO } from '../../dto';

export const toMenuItem = (option: SelectItemDTO) => (
  <MenuItem key={option.value} value={option.value}>
    {option.label}
  </MenuItem>
);
